<template>
  <div class="text-center py-20">
    <p class="text-gray-500 text-lg">No items found for "{{ searchQuery }}"</p>
    <button
      @click="clearSearch"
      class="mt-4 text-primary-600 font-bold hover:underline"
    >
      Clear Search
    </button>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "NoSearchResults",
  computed: {
    ...mapGetters(["searchQuery"])
  },
  methods: {
    ...mapMutations(["SET_SEARCH_QUERY"]),
    clearSearch() {
      this.SET_SEARCH_QUERY("");
    }
  }
};
</script>

<style></style>
